<template>
  <div class="pilula-grupo-servico">
    <a class="fonte-secundaria">
      <span v-if="texto.length < tamanhoMaximoTexto">{{ texto }}</span>
      <unicom-tooltip
        v-else
        style="display: inline-block"
        :texto="`${texto.substring(0, tamanhoMaximoTexto)}...`"
        :textoTooltip="texto"
        :tooltipLocalizacao="tooltipLocalizacao"
        :whiteSpaceNoWrap="whiteSpaceNoWrap"
        :larguraMaxima="larguraMaxima"
      />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    texto: {
      type: String,
      default: ""
    },
    tamanhoMaximoTexto: {
      type: [String, Number],
      default: 100
    },
    tooltipLocalizacao: {
      type: String,
      default: "top"
    },
    whiteSpaceNoWrap: {
      type: Boolean,
      default: false
    },
    larguraMaxima: {
      type: [String, Number],
      default: 200
    }
  }
};
</script>

<style lang="scss" scoped>
.pilula-grupo-servico {
  display: inline-block;
  padding: 8px;
  line-height: 1;
  color: #60656c;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 18px;
  border: 1px solid #60656c;
}
</style>
